import { Component, OnInit, OnDestroy } from '@angular/core';
import { StorageService } from '../../../shared/security/StorageService';
import { ChangeEmployerService } from '../change-employer.service';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { PaymentService } from '../../../shared/payment/payment.service';
import { Router } from '@angular/router';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { FeeModel } from '../../../model/feeModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { StartPaymentRequestModel } from '../../../model/startPaymentRequestModel';
import { MessageModel } from '../../../model/models';
import { Subscription } from 'rxjs';
import { ChangeEmployerResponseModel } from '../../../model/changeEmployerResponseModel';
import { EntityLicenseModel } from '../../../model/entityLicenseModel';
import { CompleteFunctionService } from '../../../shared/utils/complete-function.service';
import { CompleteFunctionRequestModel } from '../../../model/completeFunctionRequestModel';
import { StartPaymentResponseModel } from '../../../model/startPaymentResponseModel';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import * as $ from 'jquery';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-change-employer-pay',
  templateUrl: './change-employer-pay.component.html',
  styleUrls: ['./change-employer-pay.component.css']
})
export class ChangeEmployerPayComponent implements OnInit, OnDestroy {
 
  startFunction: StartFunctionResponseModel = {};
  products: Array<FeeModel> = [];
  total: number = 0;

  workflow: WorkflowModel = new WorkflowModel();
  startPaymentRequest: StartPaymentRequestModel = new StartPaymentRequestModel();

  userMessages: Array<MessageModel> = [];

  employerChangeResponseSubsription: Subscription;
  notifyScsReturnToApplicationUrlSubscription : Subscription;
  notifyEmploymentInformationSubscription : Subscription;
  notifyAgreementSubscription : Subscription;
  notifyCompleteFunctionRequestModelSubscription : Subscription;

  changeEmployerResponse: ChangeEmployerResponseModel = new ChangeEmployerResponseModel();
  ScsReturnToApplicationUrl : string = environment.changeEmployerReceiptPageReturnUrl;

  employmentInfo: EntityLicenseModel;
  agree: boolean = false;


  constructor(private storage: StorageService,
    private changeEmployerService: ChangeEmployerService,
    private completeFunctionService : CompleteFunctionService,
    private currentPageWatcher: CurrentPageWatcherService,
    private paymentService: PaymentService,
    private router: Router,
    private startFunctionService : StartFunctionService) {

     
      this.employerChangeResponseSubsription = this.changeEmployerService.getNotifySelectedEmployer().subscribe(data => {
        this.changeEmployerResponse = data;
        console.log("changeEmployerResponse : " + this.changeEmployerResponse);

      });

      this.notifyEmploymentInformationSubscription = this.changeEmployerService.getNotifyEmploymentInformation().subscribe(employmentData=>{
        this.employmentInfo = employmentData;
        console.log("Employment Info : " + this.employmentInfo);

      });

      this.notifyAgreementSubscription = this.changeEmployerService.getNotifyAgreement().subscribe(agreeData=>{
        this.agree = agreeData;
        console.log("Agree : " + this.agree);

      });

     }

  ngOnInit() {
    this.startFunction = this.storage.getStartFunctionData();

    if (this.changeEmployerResponse.Workflow != null) {
      this.workflow = this.changeEmployerResponse.Workflow;
    }
    else{
      this.workflow = this.startFunction.Workflow;
    }

    //save startFunction with updated workflow in localstorage
    this.startFunction.Workflow.CurrentStepIndex = (this.workflow.CurrentStepIndex? this.workflow.CurrentStepIndex : null);
    this.startFunction.Workflow.WorkflowID = (this.workflow.WorkflowID? this.workflow.WorkflowID : null);
    this.startFunction.Workflow.WorkflowDisplayName = (this.workflow.WorkflowDisplayName? this.workflow.WorkflowDisplayName : null);
    this.startFunction.Workflow.Fees = (this.workflow.Fees? this.workflow.Fees : null);
    this.storage.setStartFunctionData(this.startFunction);

    // fill products list from workflow fees
    this.workflow.Fees.forEach(fee => {
      let product = fee;
      product.Quantity = this.workflow.Fees.filter(e => e.FeeType == fee.FeeType).length;
      this.products.push(product);
    });
    this.products = this.workflow.Fees.map(e => e["FeeType"])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter(e => this.workflow.Fees[e]).map(e => this.workflow.Fees[e]);

    this.products.forEach(pr => {
      this.total += pr.Amount * pr.Quantity;

    });

    this.startPaymentRequest.workflowID = this.workflow.WorkflowID;
    this.startPaymentRequest.currentStepIndex = this.workflow.CurrentStepIndex;
    this.startPaymentRequest.scsReturnToApplicationUrl = this.ScsReturnToApplicationUrl;
  }
  continue() {

    this.paymentService.submitPaymentRequest(this.startPaymentRequest).subscribe((response: StartPaymentResponseModel) => {

      console.log("submitPayment resonse : ", response);
      let startPaymentResponse: StartPaymentResponseModel = response;

      response.UserMessages.forEach(msg => {
        this.userMessages.push(msg);
      })
      this.currentPageWatcher.sendUserMessages(this.userMessages);
      if (response.Summary == 0) {
       // this.startFunctionService.getNotifyStepInProgress().emit(true);
        //store information in localstorage to get them after payment 
        this.changeEmployerService.storeSelectedEmployerData(this.changeEmployerResponse);
        this.changeEmployerService.storeEmploymentInfoData(this.employmentInfo);
        this.changeEmployerService.storeAgreementData(this.agree);

        window.location.assign(startPaymentResponse.RedirectUrl);
        this.userMessages = [];
      }
      if (response.Summary == 1) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.userMessages = [];

      }

      if (response.Summary == 2) {
        this.router.navigate(["/home"]);
        this.userMessages = [];
      }

    });
  }

  goBack(){
    this.router.navigate(["/reviewEmployerChange"]).then(()=>{
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.changeEmployerService.getNotifySelectedEmployer().emit(this.changeEmployerResponse);
      this.changeEmployerService.getNotifyEmploymentInformation().emit(this.employmentInfo);
      this.changeEmployerService.getNotifyAgreement().emit(this.agree);
    
    })
  }
  
  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }

}



// WEBPACK FOOTER //
// ./src/app/broker/change-employer/change-employer-pay/change-employer-pay.component.ts